import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs";
// Connects to data-controller="video-grid-infinite-scroll"
export default class extends Controller {
  static targets = ['entries', 'pagination']

  initialize() {
    let options = {
      rootMargin: '100px',
    }

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options)
  }

  connect() {
    this.intersectionObserver.observe(this.paginationTarget)
  }

  disconnect() {
    this.intersectionObserver.observe(this.paginationTarget)
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.loadMore()
      }
    })
  }

  loadMore() {
    console.log('loding more video');
    // Disabling infinite scrool
    return false;
    let next_page = this.paginationTarget.querySelector("a[rel='next']")
    if (next_page == null) { return }
    let url = next_page.href
    this.paginationTarget.style.display = 'none'

    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (data) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', data.entries)
        this.paginationTarget.innerHTML = data.pagination
        this.paginationTarget.style.display = 'block'
        if (this.paginationTarget.querySelector("a[rel='next']") == null) {
          this.paginationTarget.style.display = 'none'
        }
      }
    })
  }
}
